import { Base } from '@studiometa/js-toolkit';
import Menu from './Menu/index.js';
import Search from './Search/index.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    components: {
      Menu,
      Search,
    },
  };

  /**
   * @type {Event}
   */
  downEvent = new Event('header-down');

  /**
   * @type {Event}
   */
  upEvent = new Event('header-up');

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props the scroll service props.
   * @param {object} props.delta The difference between the last position and the current one.
   */
  scrolled({ delta }) {
    if (window.scrollY > 15) {
      if (delta.y > 0 && !this.$el.classList.contains('header--down')) {
        this.$el.classList.add('header--down');

        this.$el.dispatchEvent(this.downEvent);
      }

      if (delta.y < 0) {
        this.$el.classList.add('header--up');
        this.$el.classList.remove('header--down');

        this.$el.dispatchEvent(this.upEvent);
      }
    }

    if (window.scrollY === 0) {
      this.$el.classList.remove('header--up');
    }
  }
}
